interface Props {
  name: string;
  type: string;
  description: string | null;
  required: boolean;
  defaultValue: string | null;
}

export function ParameterRow({ name, type, description, required, defaultValue }: Props) {
  return (
    <div className="param">
      <span className="param-name">{name}</span>
      <span className="param-type">{type}</span>
      <span className="param-desc">{description ?? ''}</span>
      {required && !defaultValue && <span className="param-req">Required</span>}
      {defaultValue && <span className="param-default">default: {defaultValue}</span>}
    </div>
  );
}
